import React, { useContext } from 'react';

import { TestCycle } from '@qality/common-model';

import { PaginationProps } from './types';

export interface TestCyclesError {
  message: string;
  response: null | {
    data: {
      message: string;
    };
  };
}

export interface TestCyclesContextProps {
  projectIds?: string;
  isLoading?: boolean;
  error: TestCyclesError | null;
  testCycles: TestCycle[];
  fetchTestCycles: (
    projectIds?: string,
    name?: string,
    page?: number,
    version?: string,
    state?: boolean | null
  ) => Promise<Array<TestCycle>>;
  pagination: PaginationProps | null;
}

const initialValues = {
  testCycles: [],
  error: null,
  pagination: null,
  fetchTestCycles: () => undefined,
};

export const TestCyclesContext =
  React.createContext<TestCyclesContextProps>(initialValues);

export const useTestCyclesContext = (): TestCyclesContextProps => {
  const value = useContext(TestCyclesContext);

  if (!value) {
    throw new Error('AddTestCasesContext used outside the provider!');
  }

  return value;
};
